import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useDispatch } from 'react-redux';
import { useRouter } from '../../../../@casino/useRouter';
import {useFormik, FormikContext} from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    mt0: {
        marginTop: 0
    },
    wrapActiveBonus: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '70%'
    },
    template: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
    },
    selectTemplate: {
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        paddingLeft: 8,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'initial',
        height: '32px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '420px'
    },
    toolbarClassName: {
        marginTop: 20,
        background: '#1c2542',
        borderColor: '#1c2542'
    },
    editorClassName: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        height: 500
    },
    textarea: {
        color: '#fff',
        background: '#1c2542',
        border: 0,
        borderRadius: '4px',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        padding: '6px',
        width: '99%',
        height: '400px',
        resize: 'none',
        outline: 'none'
    },
}))

const RulesCreate = () => {
    const router = useRouter()
    const dispatch = useDispatch();
    const classes = useStyles();

    const onSubmit = (store) => {
        console.log(store)
    }

    const initialValues = {
        type: '',
        language: '',

    }

    const formik = useFormik({onSubmit, initialValues});


    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Добавление правила" 
                labelBtn="Назад"
                button={() => {
                    router.history.push('/settings/rules/list')
                }}
            />
            <div style={{
                padding: 20,
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <div style={{display: 'flex', columnGap: 10}}>
                            <label htmlFor="type" style={{paddingBottom: 20}}>
                                <span className={classes.template}>Шаблон</span>
                                <select id="type" name="type"
                                    className={classes.selectTemplate}
                                    value={formik.values.type} onChange={(v) => formik.setFieldValue('type', v.target.value)}
                                >
                                    <option value="">Не выбран</option>
                                    <option value="help">Помощь</option>
                                    <option value="kyc">KYC политика</option>
                                    <option value="regulations">Правила сайта</option>
                                    <option value="cancellation_policy">Политика отмены платежей</option>
                                    <option value="responsible_game">Ответственная игра</option>
                                    <option value="privacy_policy">Политика конфиденциальности</option>
                                </select>
                            </label>
                            <label htmlFor="language" style={{paddingBottom: 20}}>
                                <span className={classes.template}>Язык</span>
                                <select id="language" name="language"
                                    className={classes.selectTemplate}
                                    value={formik.values.language} onChange={(v) => formik.setFieldValue('language', v.target.value)}
                                >
                                    <option value="">Не выбран</option>
                                    <option value="eng">Английский</option>
                                    <option value="rus">Русский</option>
                                    <option value="geo">Грузинский</option>
                                    <option value="try">Турецкий</option>
                                </select>
                            </label>
                        </div>
                        <label 
                            htmlFor="rules" 
                            className={clsx(classes.wrapLabel, classes.beginBonusLabel)}
                            style={{width: '100%'}}
                        >
                            <textarea 
                                name="rules" 
                                id="rules" 
                                className={classes.textarea}
                                value={formik.values.rules} 
                                onChange={(v) => formik.setFieldValue('rules', v.target.value)}>
                            </textarea>
                        </label>
                        {/* <label htmlFor="code" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                            <span className={classes.helper}>Код страны</span>
                            <input 
                                type="text" 
                                name="code" 
                                id="code" 
                                className={classes.text}
                                value={formik.values.code} 
                                onChange={(v) => !isNaN(+v.target.value) && formik.setFieldValue('code', v.target.value)}
                            />
                        </label> */}
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <span 
                                onClick={() => formik.submitForm()}
                                style={{
                                    color: '#141b33',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    background: '#ffc324',
                                    borderRadius: '4px',
                                }}
                            >
                                Добавить
                            </span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}

export default RulesCreate;